import { Group, Title } from '@mantine/core'
interface DashboardHeaderProps {
  title: string
}
const DashboardHeader = ({ title }: DashboardHeaderProps) => {
  return (
    <Group
      justify='space-between'
      align='center'
      h={{ base: 'auto', sm: 70 }}
      px={24}
      py={{ base: 16, sm: 0 }}
      style={{
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Title fw={500} fz={{ base: 'h3', sm: 'h2' }}>
        {title}
      </Title>
    </Group>
  )
}

export default DashboardHeader
